/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_UK_UA: Record<string, string> = {
    ariaAnnounceChart: 'діаграма, ${seriesCount}[number] серій',
    ariaAnnounceFlowProportionLink: 'посилання ${index} з ${count}, від ${from} до ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'вузол ${index} з ${count}, ${description}',
    ariaAnnounceGaugeChart: 'діаграма циферблата, ${caption}',
    ariaAnnounceHierarchyChart: 'ієрархічна діаграма, ${caption}',
    ariaAnnounceHierarchyDatum: 'рівень ${level}[number], ${count}[number] дочірні, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Натисніть пробіл або Enter, щоб перемкнути видимість',
    ariaLabelAddHorizontalLine: 'Додати горизонтальну лінію',
    ariaLabelAnnotationOptionsToolbar: 'Параметри анотацій',
    ariaLabelAnnotationSettingsDialog: 'Налаштування анотацій',
    ariaLabelColorPicker: 'Вибір кольору',
    ariaLabelFinancialCharts: 'Фінансові діаграми',
    ariaLabelLegend: 'Легенда',
    ariaLabelLegendItem: '${label}, Елемент легенди ${index}[number] з ${count}[number]',
    ariaLabelLegendItemUnknown: 'Невідомий елемент легенди',
    ariaLabelLegendPageNext: 'Наступна сторінка легенди',
    ariaLabelLegendPagePrevious: 'Попередня сторінка легенди',
    ariaLabelLegendPagination: 'Пагінація легенди',
    ariaLabelNavigator: 'Навігатор',
    ariaLabelNavigatorMaximum: 'Максимум',
    ariaLabelNavigatorMinimum: 'Мінімум',
    ariaLabelNavigatorRange: 'Діапазон',
    ariaLabelRangesToolbar: 'Діапазони',
    ariaLabelSettingsTabBar: 'Налаштування',
    ariaLabelZoomToolbar: 'Масштаб',
    ariaValuePanRange: '${min}[percent0to2dp] до ${max}[percent0to2dp]',
    contextMenuDownload: 'Завантажити',
    contextMenuPanToCursor: 'Прокрутити сюди',
    contextMenuToggleOtherSeries: 'Переключити інші серії',
    contextMenuToggleSeriesVisibility: 'Перемкнути видимість',
    contextMenuZoomToCursor: 'Збільшити сюди',
    dialogHeaderChannel: 'Канал',
    dialogHeaderDatePriceRange: 'Дата і ціна',
    dialogHeaderDateRange: 'Діапазон дат',
    dialogHeaderFibonacciRange: 'Рівні Фібоначчі',
    dialogHeaderLine: 'Лінія',
    dialogHeaderPriceRange: 'Діапазон цін',
    dialogHeaderText: 'Текст',
    dialogInputAlign: 'Вирівняти',
    dialogInputColorPicker: 'Колір',
    dialogInputColorPickerAltText: 'Колір тексту',
    dialogInputExtendAbove: 'Розширити вище',
    dialogInputExtendBelow: 'Розширити нижче',
    dialogInputExtendChannelEnd: 'Розширити кінець каналу',
    dialogInputExtendChannelStart: 'Розширити початок каналу',
    dialogInputExtendLeft: 'Розширити ліворуч',
    dialogInputExtendLineEnd: 'Подовжити кінець лінії',
    dialogInputExtendLineStart: 'Продовжити початок лінії',
    dialogInputExtendRight: 'Розширити вправо',
    dialogInputFibonacciBands: 'Смуги',
    dialogInputFibonacciBandsAltText: 'Смуги Фібоначчі',
    dialogInputFillColorPicker: 'Заливка',
    dialogInputFillColorPickerAltText: 'Колір заливки',
    dialogInputFontSize: 'Розмір',
    dialogInputFontSizeAltText: 'Розмір шрифту',
    dialogInputLineStyle: 'Пунктир',
    dialogInputPosition: 'Позиція',
    dialogInputReverse: 'Зворотній',
    dialogInputShowFill: 'Показати заповнення',
    dialogInputStrokeWidth: 'Вага',
    dialogInputStrokeWidthAltText: 'Вага лінії',
    iconAltTextAlignCenter: 'Центр',
    iconAltTextAlignLeft: 'Ліворуч',
    iconAltTextAlignRight: 'Праворуч',
    iconAltTextClose: 'Закрити',
    iconAltTextLineStyleDashed: 'Довгий-тіре',
    iconAltTextLineStyleDotted: 'Коротка штрихова',
    iconAltTextLineStyleSolid: 'Суцільна',
    iconAltTextPositionBottom: 'Низ',
    iconAltTextPositionCenter: 'Центр',
    iconAltTextPositionTop: 'Верх',
    inputTextareaPlaceholder: 'Додати текст',
    measurerDateRangeBars: '${value}[number] стовпців',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Обсяг ${value}',
    overlayLoadingData: 'Завантаження даних...',
    overlayNoData: 'Немає даних для відображення',
    overlayNoVisibleSeries: 'Немає видимих серій',
    overlayUnsupportedBrowser: 'Несумісна версія браузера. Будь ласка, оновіть ваш браузер.',
    seriesHistogramTooltipCount: '${yName} (кількість)',
    seriesHistogramTooltipFrequency: 'Частота',
    seriesHistogramTooltipMean: '${yName} (середнє)',
    seriesHistogramTooltipSum: '${yName} (сума)',
    toolbarAnnotationsArrow: 'Стрілка',
    toolbarAnnotationsArrowDown: 'Стрілка вниз',
    toolbarAnnotationsArrowUp: 'Стрілка вгору',
    toolbarAnnotationsCallout: 'Виноска',
    toolbarAnnotationsClearAll: 'Очистити все',
    toolbarAnnotationsComment: 'Коментар',
    toolbarAnnotationsDatePriceRange: 'Дата та ціна',
    toolbarAnnotationsDateRange: 'Діапазон дат',
    toolbarAnnotationsDelete: 'Видалити',
    toolbarAnnotationsDisjointChannel: '«Розділений канал»',
    toolbarAnnotationsDragHandle: 'Перетягнути панель інструментів',
    toolbarAnnotationsFibonacciAnnotations: 'Фібоначчі',
    toolbarAnnotationsFibonacciRetracement: 'Фібоначчі Корекція',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Фіб Тренд Базований',
    toolbarAnnotationsFillColor: 'Колір заповнення',
    toolbarAnnotationsHorizontalLine: 'Горизонтальна лінія',
    toolbarAnnotationsLineAnnotations: 'Трендові лінії',
    toolbarAnnotationsLineColor: 'Колір лінії',
    toolbarAnnotationsLineStrokeWidth: 'Товщина лінії',
    toolbarAnnotationsLineStyle: 'Стиль лінії',
    toolbarAnnotationsLock: 'Заблокувати',
    toolbarAnnotationsMeasurerAnnotations: 'Вимірювачі',
    toolbarAnnotationsNote: 'Нотатка',
    toolbarAnnotationsParallelChannel: 'Паралельний канал',
    toolbarAnnotationsPriceRange: 'Діапазон цін',
    toolbarAnnotationsQuickDatePriceRange: 'Виміряти',
    toolbarAnnotationsSettings: 'Налаштування',
    toolbarAnnotationsShapeAnnotations: 'Стрілки',
    toolbarAnnotationsText: 'Текст',
    toolbarAnnotationsTextAnnotations: 'Текстові позначки',
    toolbarAnnotationsTextColor: 'Колір тексту',
    toolbarAnnotationsTextSize: 'Розмір тексту',
    toolbarAnnotationsTrendLine: 'Трендова лінія',
    toolbarAnnotationsUnlock: 'Розблокувати',
    toolbarAnnotationsVerticalLine: 'Вертикальна лінія',
    toolbarRange1Month: '1М',
    toolbarRange1MonthAria: '1 місяць',
    toolbarRange1Year: '1р',
    toolbarRange1YearAria: '1 рік',
    toolbarRange3Months: '3М',
    toolbarRange3MonthsAria: '3 місяці',
    toolbarRange6Months: '6М',
    toolbarRange6MonthsAria: '6 місяців',
    toolbarRangeAll: 'Всі',
    toolbarRangeAllAria: 'Всі',
    toolbarRangeYearToDate: 'З початку року',
    toolbarRangeYearToDateAria: 'З початку року',
    toolbarSeriesTypeCandles: 'Свічки',
    toolbarSeriesTypeDropdown: 'Тип діаграми',
    toolbarSeriesTypeHighLow: 'Високий Низький',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Порожнисті свічки',
    toolbarSeriesTypeLine: 'Лінія',
    toolbarSeriesTypeLineWithMarkers: 'Лінія з маркерами',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Крокова Лінія',
    toolbarZoomPanEnd: 'Перемістити до кінця',
    toolbarZoomPanLeft: 'Панорама вліво',
    toolbarZoomPanRight: 'Перемістити вправо',
    toolbarZoomPanStart: 'Панорамувати на початок',
    toolbarZoomReset: 'Скинути масштабування',
    toolbarZoomZoomIn: 'Збільшити',
    toolbarZoomZoomOut: 'Зменшити масштаб',
    tooltipPaginationStatus: '${index}[number] з ${count}[number]',
};
